import { render, staticRenderFns } from "./BannerNotificationTable.vue?vue&type=template&id=1dc4784c&"
import script from "./BannerNotificationTable.vue?vue&type=script&lang=js&"
export * from "./BannerNotificationTable.vue?vue&type=script&lang=js&"
import style0 from "./BannerNotificationTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports